'use strict';

exports.__esModule = true;

var _styledBase = require('@emotion/styled-base');

var _styledBase2 = _interopRequireDefault(_styledBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return 'You have tried to stringify object returned from `css` function. It isn\'t supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).'; }

var AutosuggestFooterContainer = (0, _styledBase2.default)('div', {
	target: 'evhe6bn0',
	label: 'AutosuggestFooterContainer'
})(process.env.NODE_ENV === 'production' ? {
	name: '6y9jwu',
	styles: 'display:flex;justify-content:space-between;align-items:center;color:#8792a2;background:#f7fafc;padding:10px;height:40px;'
} : {
	name: '6y9jwu',
	styles: 'display:flex;justify-content:space-between;align-items:center;color:#8792a2;background:#f7fafc;padding:10px;height:40px;',
	map: '/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdHlsZXMvQXV0b1N1Z2dlc3RGb290ZXJDb250YWluZXIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRTZDIiwiZmlsZSI6Ii4uLy4uL3NyYy9zdHlsZXMvQXV0b1N1Z2dlc3RGb290ZXJDb250YWluZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmNvbnN0IEF1dG9zdWdnZXN0Rm9vdGVyQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcblx0ZGlzcGxheTogZmxleDtcblx0anVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuXHRhbGlnbi1pdGVtczogY2VudGVyO1xuXHRjb2xvcjogIzg3OTJhMjtcblx0YmFja2dyb3VuZDogI2Y3ZmFmYztcblx0cGFkZGluZzogMTBweDtcblx0aGVpZ2h0OiA0MHB4O1xuYDtcblxuZXhwb3J0IGRlZmF1bHQgQXV0b3N1Z2dlc3RGb290ZXJDb250YWluZXI7XG4iXX0= */',
	toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

exports.default = AutosuggestFooterContainer;